import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function VerifyEmailPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading"); // loading | success | error

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        await axios.get(`https://mbmailer.mb-techs.com/mbmailer/auth/verify/${token}`, {withCredentials: true});
        setStatus("success");
        toast.success("✅ Email verified! Redirecting to login...");
        setTimeout(() => {
          navigate("/login");
        }, 3000);
      } catch (err) {
        setStatus("error");
        toast.error("❌ Verification failed. Invalid or expired token.");
      }
    };

    verifyEmail();
  }, [token, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white p-8 rounded-lg shadow text-center">
        {status === "loading" && (
          <p className="text-lg text-gray-700 font-semibold">Verifying...</p>
        )}
        {status === "success" && (
          <p className="text-lg text-green-600 font-semibold">
            Email verified! Redirecting...
          </p>
        )}
        {status === "error" && (
          <p className="text-lg text-red-600 font-semibold">
            Verification failed.
          </p>
        )}
        <ToastContainer position="top-center" autoClose={3000} />
      </div>
    </div>
  );
}
